import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { RouteProtectionGuard } from './shared/guards/route-protection.guard';
import { routesData } from './shared/resources/routes.constant';
import { EmptyRouteComponent } from './components/empty-route/empty-route.component';
import { APP_BASE_HREF } from '@angular/common';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./components/landing/landing.module').then(
        (m) => m.LandingModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.USER_IDENTIFICATION.path,
    loadChildren: () =>
      import(
        './components/user-identification/user-identification.module'
      ).then((m) => m.UserIdentificationModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.PUBLICY_EXPOSED_PERSON.path,
    loadChildren: () =>
      import(
        './components/publicy-exposed-person/publicy-exposed-person.module'
      ).then((m) => m.PublicyExposedPersonModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.CDT_CONFIGURATION.path,
    loadChildren: () =>
      import('./components/cdt-configuration/cdt-configuration.module').then(
        (m) => m.CdtConfigurationModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.ERRORS.path,
    loadChildren: () =>
      import('./components/error/errors.module').then((m) => m.ErrorsModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.OTP.path,
    loadChildren: () =>
      import('./components/otp/otp.module').then((m) => m.OtpModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.BIOMETRY.path,
    loadChildren: () =>
      import('./components/biometrics/biometrics.module').then(
        (m) => m.BiometricsModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.ECONOMIC_ACTIVITY.path,
    loadChildren: () =>
      import('./components/economic-activity/economic-activity.module').then(
        (m) => m.EconomicActivityModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.CONTACT_INFORMATION.path,
    loadChildren: () =>
      import(
        './components/contact-information/contact-information.module'
      ).then((m) => m.ContactInformationModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.FINANTIAL_INFORMATION.path,
    loadChildren: () =>
      import(
        './components/finantial-information/finantial-information.module'
      ).then((m) => m.FinantialInformationModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.FOREIGN_CURRENCY_MOVEMENTS.path,
    loadChildren: () =>
      import(
        './components/foreign-currency-movements/foreign-currency-movements.module'
      ).then((m) => m.ForeignCurrencyMovementsModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.ACCOUNT_SETTINGS.path,
    loadChildren: () =>
      import('./components/account-settings/account-settings.module').then(
        (m) => m.AccountSettingsModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.NONDECLARATING_QUESTION.path,
    loadChildren: () =>
      import(
        './components/nondeclarating-question/nondeclarating-question.module'
      ).then((m) => m.NonDeclaratingQuestionModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.DIGITAL_SIGNATURE.path,
    loadChildren: () =>
      import('./components/digital-signature/digital-signature.module').then(
        (m) => m.DigitalSignatureModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.UPLOAD_DOCUMENTS_PRESIGNED.path,
    loadChildren: () =>
      import(
        './components/upload-documents-presigned/upload-documents-presigned.module'
      ).then((m) => m.UploadDocumentsPresignedModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.PRODUCT_SUMMARY.path,
    loadChildren: () =>
      import('./components/product-summary/product-summary.module').then(
        (m) => m.ProductSummaryModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.PRODUCT_SUMMARY_PSE.path,
    loadChildren: () =>
      import(
        './components/product-summary-pse/product-summary-pse.module'
      ).then((m) => m.ProductSummaryPseModule)
  },
  {
    path: routesData.SAVING_TIPS.path,
    loadChildren: () =>
      import('./components/saving-tips/saving-tips.module').then(
        (m) => m.SavingTipsModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.CHANNEL_ENROLLMENT.path,
    loadChildren: () =>
      import('./components/channel-enrollment/channel-enrollment.module').then(
        (m) => m.ChannelEnrollmentModule
      ),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.PSE.path,
    loadChildren: () =>
      import('./components/pse/pse.module').then((m) => m.PseModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.PERSONAL_INFORMATION.path,
    loadChildren: () =>
      import(
        './components/personal-information/personal-information.module'
      ).then((m) => m.PersonalInformationModule),
    canActivate: [RouteProtectionGuard]
  },
  {
    path: routesData.CARD_MANAGEMENT_MEDIA.path,
    loadChildren: () =>
      import(
        './components/card-management-media/card-management-media.module'
      ).then((m) => m.CardManagementModule),
    canActivate: [RouteProtectionGuard]
  },
  { path: '**', component: EmptyRouteComponent }
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      preloadingStrategy: PreloadAllModules
    })
  ],
  providers: [{ provide: APP_BASE_HREF, useValue: '/abrir-cdt-avvillas/' }]
})
export class AppRoutingModule {}
